module.exports = __webpack_public_path__ + "static/media/settelement-time.f23f5bda.svg";